import Text from "@ingka/text";
import {
  SimilaritySearchAssetDto,
  SimilaritySearchResponseDto,
} from "generated/api";
import SimilarImageCard from "../SimilarImages/SimilarImageCard";

type Props = {
  similarAssets: SimilaritySearchAssetDto[];
  status?: SimilaritySearchResponseDto["status"];
  errorMessage?: SimilaritySearchResponseDto["message"];
  responseReceived: boolean;
};

export function SimilarAssets({
  similarAssets,
  status,
  errorMessage,
  responseReceived,
}: Props) {
  let displayMessage: string | null = null;

  if (status === "timeout" || status === "error") {
    displayMessage = errorMessage ?? null;
  } else if (!responseReceived) {
    displayMessage =
      "No response was received from the similarity search service.";
  } else if (status === "success" && similarAssets.length === 0) {
    displayMessage = "No similar assets found in DAM";
  }

  return (
    <>
      <Text headingSize="xs" className="mb-space100">
        Similar assets already in DAM
      </Text>
      {displayMessage ? (
        <Text tagName="p" bodySize="s">
          {displayMessage}
        </Text>
      ) : status === "success" ? (
        <ul className="grid grid-cols-2 gap-space100">
          {similarAssets.map((file) => (
            <SimilarImageCard key={file.id} file={file} />
          ))}
        </ul>
      ) : null}
    </>
  );
}
